import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import { useParams } from "react-router-dom";
import RequestContent from "./RequestContent";
import { normalize } from "common/lib/normalize";
import { getGovtRequest } from "common/services/govt-requests.service";

const ViewGovtRequest = () => {
  const { id: requestId } = useParams();

  const [data, setData] = useState<any>({});
  const [, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getGovtRequest(requestId, {
        populate: [
          "agency",
          "sector",
          "mda",
          "mda.region",
          "paymentCategory",
          "positionType",
          "typeOfRequest",
          "createdby",
          "updatedby",
          "positionType",
        ],
      });
      setData(normalize(response.data));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [requestId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Government Request Details"
          pageTitles={[
            {
              title: "Dashboard",
              link: "/",
            },
            { title: "Government Requests", link: "/government-requests" },
          ]}
          back
        />

        <RequestContent request={data} fetchData={fetchData} />
      </Container>
    </div>
  );
};

export default ViewGovtRequest;
